import {
    TVChannelCreation,
    TVChannelList,
    TVChannelLittle,
    TVGetChannelResponse,
    TVGetConfigureChannelResponse,
} from '../../types/tvDisplay';
import { JBaseApi } from '../base';
import { ApiWrapper, BaseMessages, MaybeWithToken } from '../../types/utils';

export class TVDisplayApi extends JBaseApi {
    public createChannel<R extends TVChannelLittle = TVChannelList>(
        channel: MaybeWithToken<TVChannelCreation>,
        format = 'raw-list',
    ): Promise<ApiWrapper<Array<R>, BaseMessages>> {
        return this.network.maybePostToken({
            ...channel,
            o: 'article',
            f: 'create',
            format: format,
            type: 'tvDisplayChannel',
        });
    }

    public getChannel(params: { id: number; key: string }) {
        return this.network.post<TVGetChannelResponse>({
            ...params,
            o: 'tvDisplay',
            f: 'getChannel',
        });
    }

    public getConfigureChannel(params: { id: number }) {
        return this.network.post<TVGetConfigureChannelResponse>({
            ...params,
            o: 'tvDisplay',
            f: 'getConfigureChannel',
        });
    }
}
